module.exports = __webpack_public_path__ + "media/images/photography/sub-nav-photo-3-2e35658dcf7d4f12132db90bf0ba8d52.jpg";